module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-tired.7ae642da.png";